module.exports = __webpack_public_path__ + "img/IDcard.a2e58a91.png";